<div class="container mt-5" style="max-width:400px;">
  <h4>Recuperar contraseña</h4>
  <p class="small text-muted">Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.</p>

  <form [formGroup]="formRecuperar" (ngSubmit)="onSubmit()">
    
    <div class="form-group">
      <label for="email">Correo electrónico</label>
      <input id="email"
             type="email"
             class="form-control"
             formControlName="email"
             placeholder="nombre@email.com"
             required>
      <div *ngIf="formRecuperar.get('email')?.invalid && formRecuperar.get('email')?.touched"
           class="text-danger small">
        Ingresa un correo válido.
      </div>
    </div>

    <button type="submit" class="btn btn-primary btn-block" [disabled]="formRecuperar.invalid">
      Enviar enlace
    </button>
  </form>

  <div *ngIf="mensaje" class="alert alert-info mt-3">
    {{ mensaje }}
  </div>

  <div class="mt-3">
    <a routerLink="/login">Volver a Iniciar sesión</a>
  </div>
</div>
